/*--------------------------
    Newsletter Popup Js 
---------------------------- */ 

$(document).ready(function() {
 
setTimeout(function () {
     $("#newsletter-popup-conatiner").show();
  }, 30000);
  
 });

(function ($) {
    // USE STRICT
    "use strict";
  
      $("#newsletter-popup-conatiner").mouseup(function(e){
        var popContainer = $("#newsletter-popup-conatiner");
        var newsLatterPop = $("#newsletter-pop-up"); 
        if(e.target.id != newsLatterPop.attr('id') && !newsLatterPop.has(e.target).length)
        {
          popContainer.fadeOut();
        }
      });
      $('.hide-popup').on("click", function(){
        var popContainer = $("#newsletter-popup-conatiner");
        $('#newsletter-popup-conatiner')
        {
          popContainer.fadeOut();
        }
      });
      
       
})(jQuery);